module.exports = __webpack_public_path__ + "static/img/新闻动态-产品更新.161adee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/about_article/新闻动态-产品更新.png
// module id = 647
// module chunks = 1